import "../App.css";
import {
  tutorial2Roman1,
  tutorial2Roman2,
  tutorial2Roman3,
  tutorial2Roman4,
  tutorial2Roman5,
  tutorial2Roman6,
  tutorial2Roman7,
  tutorialButtonNextPage,
  tutorialButtonPreviousPage,
  tutorialButtonStartLevel,
  tutorialTitle
} from "../strings";

function Tutorial2Roman({ finishTutorial, page, handleNext, handlePrevious }) {

  const maxPages = 5; // Note that the first page has index 0. This means maxPages-1 is the last page.

  return (
    <div>
      <div className="tutorial-title">
        {tutorialTitle}
      </div>
      <div className="tutorial-body">
        {page === 0 && 
          <div>
            {tutorial2Roman1}
            <br></br>&nbsp;<br></br>
            {tutorial2Roman2}
          </div>
        }
        {page === 1 && 
          <div>
            {tutorial2Roman3}
          </div>
        }
        {page === 2 && 
          <div>
            {tutorial2Roman4}
            <br></br>&nbsp;<br></br>
            {tutorial2Roman5}
          </div>
        }
        {page === 3 && 
          <div>
            {tutorial2Roman6}
          </div>
        }
        {page === 4 && 
          <div>
            {tutorial2Roman7}
          </div>
        }
      </div>

      {/* Button to start level. */}
      {page === (maxPages-1) && 
        <button
        onClick={finishTutorial}
          className="tutorial-next-button"
        >
        {tutorialButtonStartLevel}
        </button>
      }

      {/* Button to go to previous page. */}
      {page > 0 && 
        <button
          onClick={handlePrevious}
          className="tutorial-previous-button"
        >
        {tutorialButtonPreviousPage}
        </button>
      }

      {/* Button to go to next page. */}
      {page < (maxPages-1) && 
        <button
          onClick={handleNext}
          className="tutorial-next-button"
        >
        {tutorialButtonNextPage}
        </button>
      }
    </div>
  );
}

export default Tutorial2Roman;
